import { useWindowDimensions } from './useWindowDimensions';

export function useMenuDimensions() {
  const { width } = useWindowDimensions();
  const isMobile = width < 1078;
  const isDesktop = width > 1684;
  return { isMobile, isDesktop };
}
